<template>
  <v-layout align-space-around justify-space-around column>
    <v-flex align-start justify-start>
      <h4 class="text-xs-left" @click="imageToggle">
        <span v-if="imageState">{{ strings.image }}</span>
        <span v-if="!imageState" class="red-text">{{ strings.image }}</span>
        <span v-if="!imageState" class="red-text ml-3">(required)</span>
        <v-icon v-if="showImages" color="text">mdi-chevron-up</v-icon>
        <v-icon v-if="!showImages" color="text">mdi-chevron-down</v-icon>
        
      </h4>
    </v-flex>
    <div v-if="showImages">
      <v-flex v-for="(image, index) in images" :key="index">
        <img class="logger-img" :src="image" alt="" />
        <v-btn
          round
          v-if="!deleting"
          small
          color="danger"
          title="Delete"
          @click="removeImage(image)"
        >
          <v-icon color="background">mdi-delete</v-icon>
        </v-btn>
      </v-flex>
      <v-flex>
        <v-text-field
          :label="strings.upload"
          @click="onPickFile"
          v-model="fileName"
        />
        <input
          type="file"
          style="display: none"
          ref="fileInput"
          accept=".jpg, .png"
          @change="onFilePicked"
        />
        <v-btn
          round
          v-if="file && !uploading"
          color="primary"
          title="Upload"
          @click="addImage"
        >
          <v-icon color="text">mdi-upload</v-icon>
        </v-btn>
      </v-flex>
    </div>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    images: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: ""
    },
    imageState: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showImages: false,
      file: null,
      uploading: false,
      deleting: false
    };
  },
  computed: {
    ...mapGetters("page", ["strings"]),
    fileName() {
      return this.file ? this.file.name : "";
    }
  },
  methods: {
    imageToggle() {
      this.showImages = !this.showImages;
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      this.file = event.target.files[0];
    },
    addImage() {
      if (!this.uploading && this.file) {
        this.$emit("updating", true);
        this.uploading = true;
        var reader = new FileReader();
        reader.onloadend = () => {
          var image = {
            id: this.id,
            content: reader.result
          };
          this.$store.dispatch("poi/AddImageToPoi", image).then(() => {
            this.$emit("updating", false);
            this.file = null;
            this.uploading = false;
          });
        };
        reader.readAsDataURL(this.file);
      }
    },
    removeImage(img) {
      if (!this.deleting) {
        this.deleting = true;
        this.$emit("updating", true);
        var image = {
          id: this.id,
          content: img
        };
        this.$store.dispatch("poi/removeImageFromPoi", image).then(() => {
          this.deleting = false;
          this.$emit("updating", false);
        });
      }
    }
  }
};
</script>

<style scoped>
.logger-img {
  max-width: 90vw;
  padding-top: 1rem;
}

.red-text {
  color: red;
}
</style>
